import React, { useEffect } from 'react';
import { Button, Form } from 'antd';

type PromptResponseFormProps = {
  children: React.ReactNode;
  onSubmit: (response: string | string[]) => void;
  value: string | string[];
  form: any;
};

const PromptResponseForm = ({ children, onSubmit, value, form }: PromptResponseFormProps) => {
  useEffect(() => {
    form.setFieldsValue({ response: value });
  }, [value]);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    form.validateFields((err: any, values: any) => {
      if (err) return;
      onSubmit(values.response);
    });
  };

  const { getFieldDecorator } = form;

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Item required>
        {getFieldDecorator('response', {
          initialValue: value,
          rules: [{ required: true, message: 'A response is required' }]
        })(children)}
      </Form.Item>

      <Button type="primary" htmlType="submit">
        Submit
      </Button>
    </Form>
  );
};

export default Form.create<PromptResponseFormProps>({ name: 'prompt_card_form' })(PromptResponseForm);
